module.exports = __webpack_public_path__ + "img/logbgc.cf0b3899.png";